import { createElement } from "react";
import { formatDistanceToNow } from "date-fns";

/**
 * Human-readable relative time (e.g. "about 1 hour ago") for an ISO
 * timestamp. Thin wrapper over date-fns so every WLM surface renders
 * timestamps identically (mirrors the AllPortalsPage precedent).
 */
export function relativeTime(iso: string): string {
  return formatDistanceToNow(new Date(iso), { addSuffix: true });
}

/**
 * Renders `relativeTime(iso)` inside a <span> whose `title` carries the
 * absolute timestamp, so hovering reveals the exact time.
 *
 * Plain .ts (not .tsx) module — built with `createElement` instead of JSX
 * syntax so it stays a non-JSX-parsed TypeScript file per the primitive's
 * file contract.
 */
export function RelativeTime({ iso }: { iso: string }) {
  return createElement("span", { title: new Date(iso).toISOString() }, relativeTime(iso));
}
